import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'
// 提现记录表列表
export const apiCashoutlogList = data => {
  return axios.request({
    url: '/cashoutlog/list',
    method: 'post',
    data
  })
}
// 提现统计
export const apiStatistics = data => {
  return axios.request({
    url: '/cashoutlog/statistics',
    method: 'post',
    data
  })
}

// 用户导出
export const apiCashoutlogExport = data => {
  return fileAxios.request({
    url: '/cashoutlog/export',
    method: 'get',
    data
  }, { responseType: 'blob' })
}

// 处理提现
export const apiCashoutOpt = data => {
  return axios.request({
    url: '/cashoutlog/opt',
    method: 'post',
    data
  })
}
